export const surveyJSON = {
    showPrevButton: false,
    completeText: {
        fr: "Envoyer",
    },
    showQuestionNumbers: false,
    width: "100%",
};
